// import { useState, useEffect } from "react";

// export default function TagManager({ type }) {
//   const [query, setQuery] = useState("");
//   const [results, setResults] = useState([]);
//   const [newTag, setNewTag] = useState({ rusname: "", engname: "", description: "" });
//   const [loading, setLoading] = useState(false);

//   const endpoint = type === "tag" ? "/api/admin/tags/search" : "/api/admin/multitags/search";

//   // Поиск
//   useEffect(() => {
//     if (!query) {
//       setResults([]);
//       return;
//     }

//     const timer = setTimeout(async () => {
//       setLoading(true);
//       try {
//         const res = await fetch(endpoint, {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ query }),
//         });
//         const data = await res.json();
//         if (type === "tag") {
//           setResults(data.tags || []);
//         } else {
//           setResults(data.multi_tags || []);
//         }
//       } catch (err) {
//         console.error("Ошибка поиска:", err);
//       } finally {
//         setLoading(false);
//       }
//     }, 400);

//     return () => clearTimeout(timer);
//   }, [query, endpoint, type]);

//   const handleAdd = async () => {
//     if (!newTag.rusname || !newTag.engname) {
//       alert("Пожалуйста, заполните русское и английское название");
//       return;
//     }

//     const addEndpoint = type === "tag" ? "/api/admin/tags/add" : "/api/admin/multitags/add";
//     const payload =
//       type === "tag"
//         ? { rusname: newTag.rusname, tag: newTag.engname, description: newTag.description }
//         : { rusname: newTag.rusname, multi_tag: newTag.engname, description: newTag.description };

//     try {
//       const res = await fetch(addEndpoint, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload),
//       });

//       const data = await res.json();
//       if (data.success) {
//         alert("Успешно добавлено");
//         setNewTag({ rusname: "", engname: "", description: "" });
//         setQuery(""); // Очистить поиск
//         setResults([]); // Очистить результаты
//       } else {
//         alert(data.error || "Ошибка при добавлении");
//       }
//     } catch (err) {
//       console.error("Ошибка добавления:", err);
//       alert("Ошибка при добавлении");
//     }
//   };

//   return (
//     <div style={{ padding: "0 20px", maxWidth: "600px" }}>
//       <h2 style={{ margin: "0px", fontSize: "14px"}}>{type === "tag" ? "Теги" : "Мультитеги"}</h2>

//       <input
//         type="text"
//         placeholder="Поиск..."
//         value={query}
//         onChange={(e) => setQuery(e.target.value)}
//         style={{ width: "100%", margin: "0px" }}
//       />

//       {loading && <p>Загрузка...</p>}

//       <ul style={{maxHeight: "26vh", overflowY: "scroll"}}>
//         {results.map((item) => (
//           <li key={item.id}>
//             <strong>{item.rusname}</strong> — {type === "tag" ? item.tag : item.multi_tag}
//             {item.description && <div style={{ fontSize: "0.9em", color: "#555" }}>{item.description}</div>}
//           </li>
//         ))}
//       </ul>

//       <hr />

//       <h3 style={{margin: "0px", fontSize: "14px"}}>Добавить {type === "tag" ? "тег" : "мультитег"}</h3>

//       <input
//         type="text"
//         placeholder="Русское название"
//         value={newTag.rusname}
//         onChange={(e) => setNewTag({ ...newTag, rusname: e.target.value })}
//         style={{ width: "100%", marginBottom: "5px" }}
//       />
//       <input
//         type="text"
//         placeholder="Английское название"
//         value={newTag.engname}
//         onChange={(e) => setNewTag({ ...newTag, engname: e.target.value })}
//         style={{ width: "100%", marginBottom: "5px" }}
//       />
//       <textarea
//         placeholder="Описание"
//         value={newTag.description}
//         onChange={(e) => setNewTag({ ...newTag, description: e.target.value })}
//         style={{ width: "100%", marginBottom: "10px" }}
//       />

//       <button onClick={handleAdd}>Добавить</button>
//     </div>
//   );
// }
import { useState, useEffect } from "react";

export default function TagManager({ type }) {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [newTag, setNewTag] = useState({ rusname: "", engname: "", description: "" });
  const [loading, setLoading] = useState(false);

  // Эндпоинты для разных типов тегов
  const endpoints = {
    tag: {
      search: "/api/admin/tags/search",
      add: "/api/admin/tags/add",
      field: "tag",
      title: "Теги",
      addTitle: "тег"
    },
    multi_tag: {
      search: "/api/admin/multitags/search",
      add: "/api/admin/multitags/add",
      field: "multi_tag",
      title: "Мультитеги",
      addTitle: "мультитег"
    },
    double_tag: {
      search: "/api/admin/doubletags/search",
      add: "/api/admin/doubletags/add",
      field: "double_tag",
      title: "Дабл-теги",
      addTitle: "дабл-тег"
    }
  };

  const cfg = endpoints[type] || endpoints.tag;

  // Поиск
  useEffect(() => {
    if (!query) {
      setResults([]);
      return;
    }

    const timer = setTimeout(async () => {
      setLoading(true);
      try {
        const res = await fetch(cfg.search, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ query }),
        });
        const data = await res.json();

        // Универсальная подстановка результатов
        const key =
          type === "tag" ? "tags" :
          type === "multi_tag" ? "multi_tags" :
          "double_tags";

        setResults(data[key] || []);
      } catch (err) {
        console.error("Ошибка поиска:", err);
      } finally {
        setLoading(false);
      }
    }, 400);

    return () => clearTimeout(timer);
  }, [query, cfg.search, type]);

  // Добавление
  const handleAdd = async () => {
    if (!newTag.rusname || !newTag.engname) {
      alert("Пожалуйста, заполните русское и английское название");
      return;
    }

    const payload = {
      rusname: newTag.rusname,
      [cfg.field]: newTag.engname,
      description: newTag.description,
    };

    try {
      const res = await fetch(cfg.add, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();
      if (data.success) {
        alert("Успешно добавлено");
        setNewTag({ rusname: "", engname: "", description: "" });
        setQuery("");
        setResults([]);
      } else {
        alert(data.error || "Ошибка при добавлении");
      }
    } catch (err) {
      console.error("Ошибка добавления:", err);
      alert("Ошибка при добавлении");
    }
  };

  return (
    <div style={{ padding: "0 20px", maxWidth: "600px" }}>
      <h2 style={{ margin: "0px", fontSize: "14px" }}>{cfg.title}</h2>

      <input
        type="text"
        placeholder="Поиск..."
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        style={{ width: "100%", margin: "0px" }}
      />

      {loading && <p>Загрузка...</p>}

      <ul style={{ maxHeight: "26vh", overflowY: "scroll" }}>
        {results.map((item) => (
          <li key={item.id}>
            <strong>{item.rusname}</strong> — {item[cfg.field]}
            {item.description && (
              <div style={{ fontSize: "0.9em", color: "#555" }}>{item.description}</div>
            )}
          </li>
        ))}
      </ul>

      <hr />

      <h3 style={{ margin: "0px", fontSize: "14px" }}>Добавить {cfg.addTitle}</h3>

      <input
        type="text"
        placeholder="Русское название"
        value={newTag.rusname}
        onChange={(e) => setNewTag({ ...newTag, rusname: e.target.value })}
        style={{ width: "100%", marginBottom: "5px" }}
      />
      <input
        type="text"
        placeholder="Английское название"
        value={newTag.engname}
        onChange={(e) => setNewTag({ ...newTag, engname: e.target.value })}
        style={{ width: "100%", marginBottom: "5px" }}
      />
      <textarea
        placeholder="Описание"
        value={newTag.description}
        onChange={(e) => setNewTag({ ...newTag, description: e.target.value })}
        style={{ width: "100%", marginBottom: "10px" }}
      />

      <button onClick={handleAdd}>Добавить</button>
    </div>
  );
}
